import {
  AccountClassification,
  AccountFragment,
  AccountMainFragment,
  AccountStatus,
  AccountType,
  BalanceFragment,
  CardFragment,
  CardPermission,
  CardWithPermissionListFragment,
  CurrencyForAccountFragment,
  GenerateQrInput,
  PaymentSystem,
  PaymentType,
} from '@/app/graphql/account/sdk.account';

export enum Currencies {
  KZT = 'KZT',
  USD = 'USD',
  EUR = 'EUR',
  RUB = 'RUB',
  KGS = 'KGS',
  GBP = 'GBP',
  CNY = 'CNY',
  JPY = 'JPY',
  AED = 'AED',
  TRY = 'TRY',
}

export type Account = AccountFragment & {
  formattedBalance?: string;
  permissions?: PaymentType[];
};

export type AccountMain = AccountMainFragment & {
  formattedBalance?: string;
  permissions?: PaymentType[];
};

export type AccountWithPaymentTypes = AccountFragment & {
  paymentTypes?: PaymentType[];
};

export interface Contract {
  account: string;
  contractNumber: string;
  accounts: Account[];
  status: AccountStatus;
}

export interface ContractMain {
  account: string;
  contractNumber: string;
  accounts: AccountMain[];
  status: AccountStatus;
}

export interface AccountsWithCurrency {
  account: string;
  accountClassification: AccountClassification;
  currency: CurrencyForAccountFragment[];
}

export interface AccountForPayment extends AccountFragment {
  paymentTypes: PaymentType[];
  availablePermissions: PaymentType[];
  cards: CardWithPermissionListFragment[];
}

export interface BaseRkoAndCardInfo {
  accountId: number;
  account: string;
  cardNum: string;
  cardHolderName: string;
  balance: number;
  currency: string;
  paymentSystem: PaymentSystem | undefined;
  accountClassification: AccountClassification;
  type: AccountType;
  disable?: boolean;
}

export interface AccountWithClassification {
  account: string;
  accountClassification: AccountClassification;
}

export interface CardAccountForQR {
  cardHolderName: string;
  cardNum: string;
  account: AccountWithClassification;
  title: string;
}
export interface AccountForQr {
  account: AccountWithClassification[];
  card: CardAccountForQR[];
}

export interface CardList extends CardFragment {
  balance: BalanceFragment[];
  permission: CardPermission[];
}

export interface AccountTypes {
  contracts: Contract[];
  cards: AccountForPayment[];
  deposits: AccountForPayment[];
  loan: Contract[];
}

export interface AccountTypes {
  contracts: Contract[];
  cards: AccountForPayment[];
  deposits: AccountForPayment[];
  loan: Contract[];
}

export interface GenerateQr {
  generateInput: GenerateQrInput;
  accountClassification: AccountClassification;
}

export interface PersonalQrRequisite {
  salePointCode: number;
  cashCode: number;
  legalPartyId: number;
}

export interface GeneratePersonalQrInput {
  sum: number | null;
  note: string;
  requisite: PersonalQrRequisite;
  allowEditSum: boolean | null;
}

export interface GeneratePersonalQrResponse {
  elQrUrl?: string;
  qrUrl?: string;
}
